var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.29 16.26c7.547 0 11.675-6.255 11.675-11.68 0-.177-.004-.354-.012-.53A8.346 8.346 0 0 0 20 1.925a8.177 8.177 0 0 1-2.356.646A4.12 4.12 0 0 0 19.448.3a8.229 8.229 0 0 1-2.606.996A4.105 4.105 0 0 0 9.85 5.04 11.65 11.65 0 0 1 1.392.751a4.095 4.095 0 0 0-.556 2.064c0 1.424.725 2.681 1.826 3.416a4.072 4.072 0 0 1-1.858-.513v.053a4.106 4.106 0 0 0 3.291 4.023 4.107 4.107 0 0 1-1.853.07 4.108 4.108 0 0 0 3.833 2.852A8.23 8.23 0 0 1 .98 14.473c-.327 0-.654-.019-.979-.057a11.612 11.612 0 0 0 6.29 1.844",
    fill: "#fff"
  })));
};
export default SvgTwitter;